module.exports = __webpack_public_path__ + "static/scale-model-of-mahany-park-in-roseville-california-d749a1d95c356b9da9e4c9d69430a8a5.png";